/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
// @mui
import { Autocomplete, Box, TextField } from '@mui/material';
// redux
import React from 'react';
import { useSelector } from '../../redux/store';
import Iconify from '../Iconify';
import { filterDropdownPaperStyle } from '../../styles/NewLead';

// -------------------------------------------------------------------------------------------

const ReferralDropdown = ({ name, value, onChange, type, ...other }) => {
    const { referral, practiceUsers } = useSelector((state) => ({
        referral: state.schema?.referral || [],
        practiceUsers: state.mergeTags?.practiceUsers || []
    }));

    const [defaultValue, setDefaultValue] = React.useState(value);

    React.useEffect(() => {
        if (other?.affiliateUser) {
            const currentClinician = practiceUsers?.filter(obj => obj?.id === other?.affiliateUser?.id)?.[0]?.value;
            setDefaultValue(currentClinician)
        } else {
            setDefaultValue(value);
        }
    }, [value])

    const options = other?.preserveClinician ? [
        ...referral.map((item) => ({ ...item, group: "Default" }))
    ] : [
        ...referral.map((item) => ({ ...item, group: "Default" }))?.filter(item => item?.value !== "CLINICIAN"),
        ...practiceUsers.map((user) => ({ ...user, group: "Clinicians" }))
    ];

    return (
        <Autocomplete
            name={name}
            value={defaultValue || null}
            onChange={onChange}
            groupBy={(option) => option.group}
            isOptionEqualToValue={(option, val) => option?.value === val?.value}
            options={options}
            renderOption={(props, option) => (
                <li {...props} key={option.value || option.label}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Iconify
                            icon={option.icon || (option.group === 'Clinicians' ? 'mdi:account' : 'mdi:help-circle-outline')}
                            sx={{ width: 20, height: 20, flexShrink: 0, color: 'text.secondary' }}
                        />
                        {option.label}
                    </Box>
                </li>
            )}
            renderInput={(params) => <TextField {...params} label="Referral" />}
            slotProps={{ paper: { sx: filterDropdownPaperStyle } }}
            sx={{ '.MuiAutocomplete-endAdornment .MuiAutocomplete-clearIndicator': { display: type === 'search' && 'none' } }}
            {...other}
        />);
};

ReferralDropdown.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    type: PropTypes.string,
};

export default ReferralDropdown;
